import { string } from '@gogame/schemas';
import { DIMENSION_CONCEPT } from '../constants';
export const dimensionSchema = string().default(DIMENSION_CONCEPT);
